import React from 'react';
import { FormControlLabel, makeStyles, Switch, TextField, Typography } from '@material-ui/core';
import i18n from 'i18n-js';

import { theme } from 'config/theme';
import { useTableMapWizard } from '../context';
import SectionTitle from '../components/SectionTitle';

const useStyles = makeStyles({
    root: {
        padding: 0,
        display: 'flex',
        flexDirection: 'column',
        gap: 20,
    },
    field: {
        width: '100%',
        maxWidth: 480,
    },
    statusLabel: {
        fontSize: 12,
        color: theme.palette.text.secondary,
        marginBottom: 4,
    },
});

export default function BasicInformationStep() {
    const classes = useStyles();
    const { draft, dispatch } = useTableMapWizard();

    function handleNameChange(e: React.ChangeEvent<HTMLInputElement>) {
        dispatch({ type: 'SET_NAME', payload: e.target.value });
    }

    return (
        <div className={classes.root}>
            <SectionTitle>{i18n.t('tableMaps.wizard.basicInformation')}</SectionTitle>

            <div className={classes.field}>
                <TextField
                    label={i18n.t('tableMaps.wizard.tableMapName')}
                    value={draft.name}
                    onChange={handleNameChange}
                    variant="outlined"
                    fullWidth
                    required
                    placeholder={i18n.t('tableMaps.wizard.tableMapNamePlaceholder')}
                    inputProps={{ 'aria-label': i18n.t('tableMaps.wizard.tableMapName') }}
                />
            </div>

            <div>
                <Typography className={classes.statusLabel}>
                    {i18n.t('tableMaps.wizard.status')}
                </Typography>
                <FormControlLabel
                    control={
                        <Switch
                            color="primary"
                            checked={draft.isActive}
                            onChange={(e) =>
                                dispatch({ type: 'SET_IS_ACTIVE', payload: e.target.checked })
                            }
                        />
                    }
                    label={
                        draft.isActive
                            ? i18n.t('tableMaps.wizard.active')
                            : i18n.t('tableMaps.wizard.inactive')
                    }
                />
            </div>
        </div>
    );
}
